import React from 'react';
import columns from '../../../../react-table/helpers/columns';
import HeaderChartButton from '../../../common/components/HeaderChartButton';
import charts from './CarrierCarditResditBestPracticeElementsCharts';
import { totalRowRatio } from '../../../../react-table/helpers/rowTotals';
import ReportDefinitions from '../../../../common/config/ReportDefinitions';
import UserTypes from '../../../../common/redux/actions/types/UserTypes';

export function get802NavigationProps(rowInfo) {
  return rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.RESDIT_74_21_PERFORMANCE_OPERATOR_802.id,
    mainReportId: ReportDefinitions.RESDIT_74_21_PERFORMANCE_OPERATOR_802.id,
    requestParams: {
      carriers: [rowInfo.row.carrierIcaoCode],
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {};
}

export function get801NavigationProps(rowInfo) {
  return rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.CARDIT_NESTING_OPERATOR_801.id,
    mainReportId: ReportDefinitions.CARDIT_NESTING_OPERATOR_801.id,
    requestParams: {
      carriers: [rowInfo.row.carrierIcaoCode],
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {};
}

export function get800NavigationProps(rowInfo) {
  return rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_800_OPERATOR.id,
    mainReportId: ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_800_OPERATOR.id,
    requestParams: {
      carriers: [rowInfo.row.carrierIcaoCode],
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {};
}

export const ownImpcProps = userType => (state, rowInfo) => {
  const className = userType !== UserTypes.IPC && rowInfo && rowInfo.original.ownCarrier ? 'bg-blue-spindle' : '';
  return { className };
};

export const isOwnOperator = userType => rowInfo =>
  userType === UserTypes.IPC ||
  (rowInfo && rowInfo.original && rowInfo.original.ownCarrier === true);

export default (data, userType) => {
  const {
    TextColumn,
    NonZeroPercentageColumn,
    NonZeroNumberColumn,
    PercentageNavigationColumn,
  } = columns(data);

  return setChartMeta => [
    {
      Header: '',
      columns: [
        new TextColumn('Carrier', 'carrier').withGetProps(ownImpcProps).withTotalHeader('Total'),
        new TextColumn('carrierIcaoCode', 'carrierIcaoCode').withShow(false),
        new NonZeroNumberColumn('receptacles', 'receptacles').withShow(false),
      ],
    },
    {
      Header: () => (
        <HeaderChartButton
          title="RESDIT"
          action={setChartMeta}
          chartMeta={charts.resdit}
        />
      ),
      columns: [
        new PercentageNavigationColumn(new NonZeroPercentageColumn('74', 'resdit.resdit74').withGetProps(ownImpcProps(userType)).withTotalHeader(totalRowRatio(['resdit.nbrResdit74', 'resditMeasurable'])), get802NavigationProps, isOwnOperator(userType)),
        new PercentageNavigationColumn(new NonZeroPercentageColumn('21', 'resdit.resdit21').withGetProps(ownImpcProps(userType)).withTotalHeader(totalRowRatio(['resdit.nbrResdit21', 'resditMeasurable'])), get802NavigationProps, isOwnOperator(userType)),
        new NonZeroNumberColumn('', 'resdit.nbrResdit74').withShow(false),
        new NonZeroNumberColumn('', 'resdit.nbrResdit21').withShow(false),
        new NonZeroNumberColumn('', 'resditMeasurable').withShow(false),
      ],
    },
    {
      Header: () => (
        <HeaderChartButton
          title="Nesting"
          action={setChartMeta}
          chartMeta={charts.nesting}
        />
      ),
      columns: [
        new NonZeroNumberColumn('', 'nesting.nbrCjid').withShow(false),
        new NonZeroNumberColumn('', 'nesting.nbrUldId').withShow(false),
        new NonZeroNumberColumn('', 'criticalMeasurable').withShow(false),
        new PercentageNavigationColumn(new NonZeroPercentageColumn('CJID', 'nesting.cjid').withGetProps(ownImpcProps(userType)).withTotalHeader(totalRowRatio(['nesting.nbrCjid', 'criticalMeasurable'])), get801NavigationProps, isOwnOperator(userType)),
        new PercentageNavigationColumn(new NonZeroPercentageColumn('ULD ID', 'nesting.uldId').withGetProps(ownImpcProps(userType)).withTotalHeader(totalRowRatio(['nesting.nbrUldId', 'criticalMeasurable'])), get801NavigationProps, isOwnOperator(userType)),
      ],
    },
    {
      Header: () => (
        <HeaderChartButton
          title="Critical elements"
          action={setChartMeta}
          chartMeta={charts.criticalElements}
        />
      ),
      columns: [
        new PercentageNavigationColumn(new NonZeroPercentageColumn('LHOT origin', 'criticalElements.lhotOrigin').withGetProps(ownImpcProps(userType)).withTotalHeader(totalRowRatio(['criticalElements.nbrLhotOrigin', 'criticalMeasurable'])), get800NavigationProps, isOwnOperator(userType)),
        new PercentageNavigationColumn(new NonZeroPercentageColumn('LHOT destination', 'criticalElements.lhotDestination').withGetProps(ownImpcProps(userType)).withTotalHeader(totalRowRatio(['criticalElements.nbrLhotDestination', 'criticalMeasurable'])), get800NavigationProps, isOwnOperator(userType)),
        new PercentageNavigationColumn(new NonZeroPercentageColumn('Contract reference', 'criticalElements.contractReference').withGetProps(ownImpcProps(userType)).withTotalHeader(totalRowRatio(['criticalElements.nbrContractReference', 'criticalMeasurable'])), get800NavigationProps, isOwnOperator(userType)),
        new PercentageNavigationColumn(new NonZeroPercentageColumn('Booking reference (PAWB)', 'criticalElements.bookingReference').withGetProps(ownImpcProps(userType)).withTotalHeader(totalRowRatio(['criticalElements.nbrBookingReference', 'criticalMeasurable'])), get800NavigationProps, isOwnOperator(userType)),
        new NonZeroNumberColumn('', 'criticalElements.nbrLhotOrigin').withShow(false),
        new NonZeroNumberColumn('', 'criticalElements.nbrLhotDestination').withShow(false),
        new NonZeroNumberColumn('', 'criticalElements.nbrContractReference').withShow(false),
        new NonZeroNumberColumn('', 'criticalElements.nbrBookingReference').withShow(false),
      ],
    },
    {
      Header: () => (
        <HeaderChartButton
          title="RESDIT"
          action={setChartMeta}
          chartMeta={charts.resdit}
        />
      ),
      columns: [
        new NonZeroPercentageColumn('On time', 'cardit.onTime').withGetProps(ownImpcProps(userType)).withTotalHeader(totalRowRatio(['cardit.nbrOnTime', 'timelinessMeasurable'])),
        new NonZeroNumberColumn('', 'cardit.nbrOnTime').withShow(false),
        new NonZeroNumberColumn('', 'timelinessMeasurable').withShow(false),
      ],
    },
  ];
};
